import { render, staticRenderFns } from "./PackageVersionMilestoneDpField.vue?vue&type=template&id=d7c4b3b4"
import script from "./PackageVersionMilestoneDpField.vue?vue&type=script&lang=ts"
export * from "./PackageVersionMilestoneDpField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d7c4b3b4')) {
      api.createRecord('d7c4b3b4', component.options)
    } else {
      api.reload('d7c4b3b4', component.options)
    }
    module.hot.accept("./PackageVersionMilestoneDpField.vue?vue&type=template&id=d7c4b3b4", function () {
      api.rerender('d7c4b3b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientScripts/Components/Dropdowns/PackageVersionMilestoneDpField.vue"
export default component.exports